<template>
  <div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">清远市医用可回收物监控管理平台</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <!-- <div class="model"> -->
        <!-- <div class="model_title">【企业介绍】</div> -->
        <!-- <div class="section"></div> -->
        <!-- </div> -->
        <div class="model">
          <div class="model_title">【项目概况】</div>
          <div>
            <div class="section">
              目前清远市区新城、旧城及工业园区范围内注册登记的1100家企业中，再生资源回收公司18家，回收站点214个，回收站点固定从业人员近500人（不包括流动收购人员）。而这些回收站点中，有营业执照的只有61个，占经营点28％。随着清远市经济的发展，人民生活水平的提高，特别是城市的快速发展与扩张，生产和生活废旧物资日益增加，再生资源的回收利用工作任务越来越繁重。
            </div>
             <div class="section">
              医疗废物在线监控管理平台实现对医疗可回收物、尤其是危险废物从产生、收集、贮存、运输和处理处置等环节的全生命周期监管，并应用视频监视、GPS跟踪、卫星遥感等技术手段，形成点、线、面全方位的立体监控网络。通过分析决策和辅助执法功能模块的设置，降低对现场人员的专业性要求，提高监管的效率、精准性和一致性，在不大幅增加管理部门工作人员情况下更高效、高质地开展监管工作。
            </div>
            <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail2/1.png" alt="" />
            </div>
              <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail2/2.png" alt="" />
            </div>
              <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail2/3.png" alt="" />
            </div>
              <!-- <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail2/1.png" alt="" />
            </div> -->
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            利用物联网技术，对企业信息进行管理，规范其基础信息，收集企业工况信息，为信息的备案提供媒介
          </div>
          <div class="section">
            结合GPS、GIS等功能完成运输车辆的转移过程监管，并结合医用可回收物转移条形码电子联单，推行医用可回收物转移运输全过程定位跟踪监控，及时汇集全流向、闭环化的医用可回收物信息数据，实现医用可回收物回收全生命周期信息共享和全面监管。
          </div>
          <div class="section">
            建立了可回收物数据中心用于存储医用可回收物相关业务办理过程中所产生的庞大数据，并合理的运用该数据进行分析，为管理部门提供决策支持。
          </div>
          <div class="section">
            整合现有的医用可回收物监管数据（原有系统、文件内数据等），实现了医用可回收物管理从“摇篮”到“坟墓”的全过程监管。
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseZhongZaiShengDetail2",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        // padding-left: 2.0em;
        img {
          width: 2.4rem;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseZhongZaiShengDetail2.vue